import { Button } from "@chakra-ui/react";
import { createLink, LinkComponent } from "@tanstack/react-router";
import * as React from "react";

type ChakraLinkButtonProps = Omit<
  React.ComponentPropsWithoutRef<typeof Button>,
  "href"
>;

const ChakraLinkComponent = React.forwardRef<
  HTMLAnchorElement,
  ChakraLinkButtonProps
>(({ isDisabled, ...props }, ref) => {
  return (
    <Button
      {...(isDisabled ? { "data-disabled": true } : {})}
      as="a"
      {...props}
      ref={ref}
    />
  );
});

const CreatedLinkComponent = createLink(ChakraLinkComponent);

export const LinkButton: LinkComponent<typeof ChakraLinkComponent> = (
  props,
) => {
  return <CreatedLinkComponent preload={"intent"} {...props} />;
};
